// Reshape
export const ORIGINAL_DATA = '__OriginalData__'
export const Separator = '-'

// Measures
export const FoldMeasureName = '__MeaName__'
export const FoldMeasureId = '__MeaId__'
export const FoldMeasureValue = '__MeaValue__'
export const MeasureId = FoldMeasureId
export const MeasureName = FoldMeasureName

// Measures For DualAxis
export const FoldPrimaryMeasureValue = '__MeaPrimaryValue__'
export const FoldSecondaryMeasureValue = '__MeaSecondaryValue__'
export const DimAxisType = '__Dim_AxisType__'

// Measures For Scatter
export const FoldXMeasureValue = '__MeaXValue__'
export const FoldYMeasureValue = '__MeaYValue__'
export const FoldXMeasureId = '__MeaXId__'
export const FoldYMeasureId = '__MeaYId__'
// Encoding
// Stable full-dimensional group, independent of visual channels and folded measures.
export const DimensionKey = '__Dim_Key__'
export const XEncoding = '__Dim_X__'
export const YEncoding = '__Dim_Y__'
export const AngleEncoding = '__Dim_Angle__'
export const DetailEncoding = '__Dim_Detail__'
export const PlayerEncoding = '__Dim_Player__'
export const ColorEncoding = '__Dim_Color__'
export const ColorIdEncoding = '__Dim_ColorId__'
export const HierarchyEncoding = '__Dim_Hierarchy__'
export const SourceEncoding = '__Dim_Source__'
export const TargetEncoding = '__Dim_Target__'

// Measures For boxPlot
export const BoxPlotPivotIndicator = '__BoxPlot_Pivot_Indicator__'
export const Q1MeasureValue = '__Q1__'
export const Q3MeasureValue = '__Q3__'
export const LowerWhisker = '__Lower_Whisker__'
export const UpperWhisker = '__Upper_Whisker__'
export const OutliersMeasureId = '__Outliers__'
export const MedianMeasureId = '__Meadian__'

// Measures For Histogram
export const BinStartMeasureId = '__BinStart__'
export const BinEndMeasureId = '__BinEnd__'
export const BinCountMeasureId = '__BinCount__'
export const BinPercentageMeasureId = '__BinPercentage__'

// Inner row index for code execute
export const InnerRowIndex = '__row_index'
